import React, { useMemo, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
export default function NewLifetimeSalesBreakDownService(props: any) {
  const { style, className, config, children, segmentVal, ...resetProps } = props || {};
  const { api, refreshKey = '', interval, metric = [], byType, topMetric, extMetricMap } = config || {};
  const { by_tab, by_top10_metric } = props?.data || {};
  const [sortTopMetric, setSortTopMetric] = useState(topMetric);
  
  const oldTopMetric = useRef();

  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    segmentVal,
    sortTopMetric,
    by_tab,
    metric,
    topMetric,
    by_top10_metric,
    ...resetProps
  }), [by_tab, by_top10_metric, gameCode, metric, segmentVal, sortTopMetric, topMetric]);
  const formatData = (data: any) => data?.dwm_list || {};

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={'breakDownData'}
        refreshKey={refreshKey}
        interval={interval}
        formatData={formatData}
        beforeRequest={(data) => {
          const { filterVal, gameCode, segmentVal, sortTopMetric, metric, by_top10_metric } = data;
          const { singleDaily, timeType, ...filters } = filterVal || {};

          // 传参兜底筛选器参数
          const typeKey = typeof byType === 'function' ? byType(segmentVal) : byType;
          const params: any = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_time: singleDaily,
            end_time: singleDaily,
            period: PERIODTIMEOBJ[timeType],
            metrics: metric,
            accumulation: {
              [typeKey]: true
            },
            top_metric: sortTopMetric,
          };
          // 解决更改排序后，切换指标导致top_metric传参有问题
          if (oldTopMetric.current !== by_top10_metric) {
            params.top_metric = topMetric;
            oldTopMetric.current = by_top10_metric;
          }
          return params;
        }}
        trackData={['gameCode', 'segmentVal', 'sortTopMetric', 'by_tab', 'metric', 'by_top10_metric']}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...(resetProps || {}),
            extMetricMap,
            segmentVal,
            setSortTopMetric
          }
        ))}
      </Service>
    </div>
  );
};